import { StateCreator } from 'zustand'
import { FilterValues, AppliedSlice, FilterStore } from './types'

const emptyApplied: FilterValues = {
  orgId: undefined,
  buildingId: undefined,
  // ADD HERE
}

export const createAppliedSlice: StateCreator<FilterStore, [], [], AppliedSlice> = (set, get) => ({
  applied: emptyApplied,

  applyDraft() {
    set({
      applied: {
        ...get().draft,
      },
    })
  },

  applyDefaults() {
    set({
      applied: {
        ...get().defaults,
      },
    })
  },

  applyDefaultsByKey(key: keyof FilterValues) {
    set({
      applied: {
        ...get().applied,
        [key]: get().defaults[key],
      },
    })
  },
})
